import React from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from 'reactstrap'
import { connect } from 'react-redux'

import { withTranslation } from 'react-i18next'

import AlertMessage from '../../components/AlertMessage'
import FormInputField from '../../components/FormInputField'
import integrationsActions from '../../integrations/actions'
import PageLoader from '../../components/PageLoader'

class GitlabIntegrationModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      gitlabPrivateToken: props.integration.private_token,
      gitlabUrl: props.integration.url || 'https://gitlab.com'
    }
  }

  componentDidUpdate(prevProps) {
    const { updateStatus: prevUpdateStatus } = prevProps
    const { onClose, updateStatus } = this.props

    if (prevUpdateStatus === 'updating' && updateStatus === 'succeeded') {
      onClose()
    }
  }

  setGitlabPrivateToken(gitlabPrivateToken) {
    this.setState({
      gitlabPrivateToken
    })
  }

  setGitlabUrl(gitlabUrl) {
    this.setState({
      gitlabUrl
    })
  }

  saveIntegration() {
    const { dispatch, integration } = this.props
    const { gitlabPrivateToken, gitlabUrl } = this.state

    if (gitlabPrivateToken === '') {
      this.privateTokenField.showAsInvalid()
    } else if (gitlabUrl === '') {
      this.urlField.showAsInvalid()
    } else {
      dispatch(integrationsActions.update(
        integration.id,
        gitlabPrivateToken,
        gitlabUrl
      ))
    }
  }

  render() {
    const {
      integration,
      isOpen,
      onClose,
      t,
      updateError,
      updateStatus
    } = this.props

    const { gitlabPrivateToken, gitlabUrl } = this.state
    const isUrlEditable = integration.state === 'authentication_failed'
      || integration.state === 'fetching_failed'

    return (
      <Modal isOpen={isOpen} toggle={() => onClose()}>
        <Form>
          <ModalHeader>
            {t(`Integrations.stateDescriptions.${integration.state}`, { platform: 'Gitlab' })}
          </ModalHeader>
          <ModalBody className="d-flex flex-column">
            <FormInputField
              disabled={!isUrlEditable}
              inputId="gitlab-url"
              inputName="gitlab_url"
              inputType="text"
              labelText={t('Integrations.fields.url')}
              onChange={({ target: { value } }) => this.setGitlabUrl(value)}
              ref={(component) => { this.urlField = component }}
              value={gitlabUrl}
            />
            {!isUrlEditable && (
              <small className="text-muted mb-3 d-block" style={{ marginTop: '-0.5rem' }}>
                {t('Integrations.fields.urlLockedHint')}
              </small>
            )}

            <FormInputField
              inputId="gitlab-private-token"
              inputName="gitlab_private_token"
              inputType="text"
              labelText={t('Integrations.fields.privateToken')}
              onChange={({ target: { value } }) => this.setGitlabPrivateToken(value)}
              ref={(component) => { this.privateTokenField = component }}
              value={gitlabPrivateToken}
            />
            {(updateStatus === 'updating') && (
              <PageLoader message="updating integration" />
            )}
            {updateError && (
              <AlertMessage>
                {typeof updateError === 'string'
                  ? updateError
                  : t('errors.somethingWentWrong', { ns: 'commons' })}
              </AlertMessage>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => onClose()}>
              {t('buttons.cancel', { ns: 'commons' })}
            </Button>
            <Button
              color="primary"
              onClick={() => this.saveIntegration()}
            >
              {t('buttons.save', { ns: 'commons' })}
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    )
  }
}

GitlabIntegrationModal.defaultProps = {
  updateError: null,
  updateStatus: 'idle'
}

GitlabIntegrationModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  integration: PropTypes.shape({
    id: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    private_token: PropTypes.string.isRequired,
    url: PropTypes.string
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  updateError: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  updateStatus: PropTypes.string
}

const mapStateToProps = ({
  integrations: {
    updateError,
    updateStatus
  }
}) => ({
  updateError,
  updateStatus
})

export default withTranslation(['SettingsPage', 'commons'])(
  connect(mapStateToProps)(GitlabIntegrationModal)
)
